export const gatewayFetch = $fetch.create({
  method: 'POST',
  async onRequest({ options }) {
    const { getIdToken } = useAuth()
    const config = useRuntimeConfig()

    options.baseURL = config.public.CF_NEW_GATEWAY_URL
    options.headers.set('Authorization', 'Bearer ' + await getIdToken())
  },
})
